import {Component, computed, inject, input} from '@angular/core';
import {IItem} from '../../../../../../types/IItem';
import {ResultsStore} from '../../../../../../shared/store/results.store';
import {getSourceAvailabilityByType, getSourceOnHandByType, getSourcesByType} from '../../../../../../shared/utils/availability.utils';
import { ResultsTableRowAvailabilityBadgeLocalComponent } from './results-table-row-availability-badge-local/results-table-row-availability-badge-local.component';
import { ResultsTableRowAvailabilityBadgeTransferComponent } from './results-table-row-availability-badge-transfer/results-table-row-availability-badge-transfer.component';
import { ResultsTableRowAvailabilityBadgeDistributorComponent } from './results-table-row-availability-badge-distributor/results-table-row-availability-badge-distributor.component';
import {SettingsService} from '../../../../../../shared/services/settings.service';

@Component({
  selector: 'app-results-table-row-availability-badge',
  standalone: true,
  imports: [ResultsTableRowAvailabilityBadgeLocalComponent, ResultsTableRowAvailabilityBadgeTransferComponent, ResultsTableRowAvailabilityBadgeDistributorComponent],
  templateUrl: './results-table-row-availability-badge.component.html',
  styleUrl: './results-table-row-availability-badge.component.css'
})
export class ResultsTableRowAvailabilityBadgeComponent {
  item = input.required<IItem>();
  private resultsStore = inject(ResultsStore);
  private settings = inject(SettingsService);

  price = computed(() => (cost: number) =>
    this.resultsStore.getPricing()(this.item().id, cost)?.price ?? 0
  );

  protected orderedAvailability = computed(() => {
    const groups = [
      {type: 'local', data: this.local()},
      {type: 'transfer', data: this.transfer()},
      {type: 'distributor', data: this.distributor()}
    ];

    const orderMap = new Map(
      this.settings.get('availability_order').value.map((item: any) => [item.type, item.order])
    );

    return groups.sort((a, b) => {
      const aOrder = orderMap.get(a.type) ?? 999;
      const bOrder = orderMap.get(b.type) ?? 999;
      return (aOrder as number) - (bOrder as number);
    });
  });

  local = computed(() => {
    const sources = getSourcesByType(this.item().availability, 'local');
    const total = Math.max(getSourceOnHandByType(this.item().availability, 'local'), 0);
    const available = getSourceAvailabilityByType(this.item().availability, 'local');

    return {source: sources[0] ?? null, total: total > 99 ? '99+' : total, available: available > 99 ? '99+' : available};
  });

  transfer = computed(() => {
    const sources = getSourcesByType(this.item().availability, 'transfer');
    const total = Math.max(getSourceOnHandByType(this.item().availability, 'transfer'), 0);
    const available = getSourceAvailabilityByType(this.item().availability, 'transfer');

    return {sources, total: total > 99 ? '99+' : total, available: available > 99 ? '99+' : available};
  });

  distributor = computed(() => {
    const sources = getSourcesByType(this.item().availability, 'distributor');
    const total = Math.max(getSourceOnHandByType(this.item().availability, 'distributor'), 0);
    const available = getSourceAvailabilityByType(this.item().availability, 'distributor');

    return {sources, total: total > 99 ? '99+' : total, available: available > 99 ? '99+' : available};
  });
}
